import classNames from 'classnames';

import BaseCenteredContent from '@picsart/rc/old/CenteredContent';

import useStyles from './styles';

import type { CenterAlignedContentType } from './types';

function CenteredContent({ className, children, appLayout }: CenterAlignedContentType) {
  const styles = useStyles();

  return (
    <BaseCenteredContent
      className={classNames(className, {
        [styles.appLayout]: appLayout,
      })}
    >
      {children}
    </BaseCenteredContent>
  );
}

export default CenteredContent;
